import {
	to as convert,
	ColorSpace,
	P3_Linear,
	XYZ_D65
} from "./node_modules/colorjs.io/src/index-fn.js";
import fourColorMixFn from '/lib/fourColorMixFn.js';
import drawLabel from '/lib/drawLabel.js';


// slight perf improvement from providing these instead of strings
const linearP3 = ColorSpace.register(P3_Linear);
const xyz = ColorSpace.register(XYZ_D65);


import config from '/lib/config.js';

import initializeThreeScene from '/lib/initializeThreeScene.js';
import unitSquareGridPoints from '/lib/unitSquareGridPoints.js';
import pointsToContextSpace from '/lib/pointsToContextSpace.js';
import pointsToSheetInContextSpace from '/lib/pointsToSheetInContextSpace.js';
import drawXYZaxesAndLabels from '/lib/drawXYZaxesAndLabels.js';

import reorderArray from '/lib/reorderArray.js';

// setup
const { scene, camera, renderer, controls } = initializeThreeScene(
	[2,2,2],
	[0.5,0.5,0.5]
);
document.getElementById('xyz-slice').appendChild(renderer.domElement);

const faceDensity = 6;

// faces
const faces = [

	/* 
	  yellow
	red  green
	   black   
	*/
	unitSquareGridPoints(faceDensity).map( row => 
		row.map( xy => [ xy[0], xy[1], 0 ] )
	),

	/* 
	 magenta
	blue  red
	  black   
	*/
	unitSquareGridPoints(faceDensity).map( row =>
		row.map( xy => [ xy[1], 0, xy[0] ] )
	),

	/* 
	  cyan
	green  blue
	  black   
	*/
	unitSquareGridPoints(faceDensity).map( row =>
		row.map( xy => [ 0, xy[0], xy[1] ] )
	),

	/* 
	   white
	yellow  cyan
	   green   
	*/
	unitSquareGridPoints(faceDensity).map( row =>
		row.map( xy => [ xy[0], 1, xy[1] ] )
	),

	/* 
	    white
	magenta  yellow
	     red   
	*/
	unitSquareGridPoints(faceDensity).map( row =>
		row.map( xy => [ 1, xy[1], xy[0] ] )
	),

	/* 
	    white
	cyan  magenta
	    blue   
	*/
	unitSquareGridPoints(faceDensity).map( row =>
		row.map( xy => [ xy[1], xy[0], 1 ] )
	)

];


// points (for debugging/construction)

// //  big corner points
// 
// const corners = {
// 	black:   [ 0, 0, 0 ],
// 	red:     [ 1, 0, 0 ],
// 	lime:    [ 0, 1, 0 ], // css named color for all green...
// 	blue:    [ 0, 0, 1 ],
// 	yellow:  [ 1, 1, 0 ],
// 	cyan:    [ 0, 1, 1 ],
// 	magenta: [ 1, 0, 1 ], 
// 	white:   [ 1, 1, 1 ]
// };
// 
// pointsToContextSpace( 
// 	linearP3, // points ColorSpace
// 	xyz, // context ColorSpace
// 	[ 0, 1, 2 ], // context space to XYZ x -> x, y -> y, z -> z
// 	0.1, // point size
// 	Object.values( corners ) // points
// ).forEach( point => scene.add(point) );
// 
// // little face points
// faces.forEach( facePoints => 
// 	pointsToContextSpace( 
// 		linearP3, // points ColorSpace
// 		xyz, // context ColorSpace
// 		[ 0, 1, 2 ], // context space to XYZ L -> y, a -> x, b -> z
// 		0.05, // point size
// 		facePoints.flat() // points
// 	).forEach( point => scene.add(point) )
// );



// solid mesh
faces.forEach( facePoints => {
	const sheet = pointsToSheetInContextSpace(
		linearP3, // points ColorSpace
		xyz, // context ColorSpace
		[ 0, 1, 2 ], // context space to XYZ L -> y, a -> x, b -> z
		facePoints, // points
		0.1, //opacity
		false // double-sided
	);
	scene.add(sheet);
} );


// slice mesh
const mixFn = fourColorMixFn( 	
	[0, 0, 0],
	[0.40, 0.25, 0.05],
	[0.30, 0.50, 0.10],
	[0.70, 0.75, 0.15]
 );

const sliceFacePoints = unitSquareGridPoints(faceDensity).map( row => 
	row.map( xy => mixFn( xy[0], xy[1] ) )
)

/*

     1,1
    / |
 1,0  |   
 |    |
 |    |
 |  0,1
 |  /
0,0 


 a+d,b+e,c+f
    / |
a,b,c |   
 |    |
 |    |
 |  d,e,f
 |  /
0,0,0 


*/
const sliceSheet = pointsToSheetInContextSpace(
	xyz, // points ColorSpace
	xyz, // context ColorSpace
	[ 0, 1, 2 ], // context space to XYZ L -> y, a -> x, b -> z
	sliceFacePoints, // points
	1, //opacity
	true // double-sided
);

scene.add( sliceSheet );



// can't do swatches because of colorspace problems?
const circleScale = 0.0625;
const circle = drawLabel(
	new URL('/assets/circle.svg', import.meta.url).href,
	mixFn(0,0),
	[circleScale, circleScale, circleScale]
);
circle.material.depthTest = false;
scene.add(circle);

// axes and labels

drawXYZaxesAndLabels( scene );


// render

// gonna need to hood this up to other sliders...
let redLightInput = document.querySelector('input#left_input');
let greenLightInput = document.querySelector('input#right_input');
function animate() {
	requestAnimationFrame( animate );
	controls.update();
	const circleLocation = mixFn( greenLightInput.value, redLightInput.value );
	circle.position.x = circleLocation[0];
	circle.position.y = circleLocation[1];
	circle.position.z = circleLocation[2];
	renderer.render( scene, camera );
}
animate();